import React from "react";
import "./parts.css"; // On ajoute un fichier CSS pour le style
import SwitchToggle from "../../components/SwitchToggle";
import { Box, TextField } from "@mui/material";
import useStyles from '../../../../../../styles/global-mui.js';

const SelectTitleComment = ({ event, onChange, keyValue = "text" }) => {

  const classes = useStyles();

  return (
    <Box className="small-padding">
      <TextField
        fullwidth
        label="Titre"
        className={classes.customInput}
        placeholder="Saisir le titre..."
        value={event.title || ""}
        sx={{ width: "100%"}}
        onChange={(e) => onChange("title", e.target.value)}
        >
        </TextField>
      <Box className="small-padding"></Box>
      
      <TextField
        fullwidth
        label="Commentaire"
        className={classes.customInput}
        placeholder="Ajouter un commentaire..."
        value={event[keyValue] || ""}
        onChange={(e) => onChange(keyValue, e.target.value)}
        sx={{ width: "100%" }}  
        multiline
        rows={3}
        >
        </TextField>

      {event.hasOwnProperty("isAutomaticCommentary") && (
        <SwitchToggle
          label="Commentaire automatique"
          checked={event.isAutomaticCommentary}
          onSwitch={(value) => onChange("isAutomaticCommentary", value)}
        />
      )}
    </Box>
  );
};

export default SelectTitleComment;
